<template>
  <div class="filter__item">
    <label class="filter__item__title">
      {{ $t('autocaller_v2.stats.filter.status') }}
    </label>
    <div class="filter__item__body">
      <i-select :value="value" :filterable="true" :clearable="true" @input="input">
        <i-option
          v-for="(label, key) in $t('autocaller_v2.stats.state')"
          :key="key"
          :label="label"
          :value="key"
        />
      </i-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
